module.exports = __webpack_public_path__ + "img/home-hero-image_large.0bda97e2.webp";